export default "__VITE_ASSET__90303787__"